module.exports = __webpack_public_path__ + "static/media/typing.47dc459e.gif";